// extracted by mini-css-extract-plugin
module.exports = {"app":"main-layout_app__1J5I9","main":"main-layout_main__IAUli"};